exports.weeksAndDays = function (value, dense) {
  // const $i18n = window.$i18n
  if (value && !isNaN(Number(value))) {
    let ageDays = Math.round(value)
    let weeks = parseInt(ageDays / 7)
    let days = Math.round(ageDays % 7)
    let wordWeeks = weeks > 1 ? 'semanas' : 'semana'
    let wordDays = days > 1 ? 'dias' : 'dia'
    if (dense) return `${weeks}s${days > 0 ? `${days}d` : ''}`
    else return `${weeks} ${wordWeeks} ${days > 0 ? `e ${days} ${wordDays}` : ''}`
  } else {
    return value
  }
}

exports.decimal = function (value) {
  const val = parseFloat(value)
  if (isNaN(val) || value === '') {
    return value
  } else {
    return val.toFixed(2)
  }
}

exports.precision = function (value, digits) {
  if (isNaN(value) || value === '') {
    return value
  } else {
    const val = parseFloat(value)
    return val.toFixed(digits || 0)
  }
}

exports.cpf = function (value) {
  if (value && value.length === 11) {
    return `${value.substr(0, 3)}.${value.substr(3, 3)}.${value.substr(6, 3)}-${value.substr(9, 2)}`
  } else {
    return '---'
  }
}



// WEBPACK FOOTER //
// ./functions/shared/filters.js